import type { Messages } from './en';

/**
 * Fase E (paquete Ximen): Ximending y el templo de Longshan / Wanhua.
 * Las líneas de práctica de inglés se quedan en inglés a propósito.
 */
export const esXimen: Pick<Messages, 'ximen'> = {
  ximen: {
    mapNames: {
      ximen: 'Ximending',
      longshan: 'Templo de Longshan',
    },
    zones: {
      ximen: 'Ximending',
      longshan: 'Templo de Longshan · Wanhua',
      xmCinemaPark: 'Parque del Cine de Taipéi',
      xmCinemaStreet: 'Calle del Cine (電影街)',
      xmSquare: 'Plaza de los artistas callejeros',
      xmEmei: 'Calle Emei',
      xmExit6: 'MRT Ximen · Salida 6',
      xmRedHouse: 'La Casa Roja (西門紅樓)',
      xmChengdu: 'Calle Chengdu',
      xmZhonghua: 'Calle Zhonghua',
      xmTemple: 'Templo de Longshan de Bangka',
      xmHerbAlley: 'Callejón de las Hierbas (青草巷)',
      xmHuaxi: 'Mercado nocturno de la calle Huaxi',
      xmBopiliao: 'Barrio histórico de Bopiliao',
      xmOldWanhua: 'Wanhua antiguo',
      xmBangka: 'Parque de Bangka',
    },
    objects: {
      xm_exit6: 'Salida 6 del MRT',
      xm_mapBoard: 'Mapa del barrio',
      xm_meesua: 'Puesto de mee sua',
      xm_chicken: 'Puesto de pollo frito',
      xm_ice: 'Mostrador de hielo raspado',
      xm_sticker: 'Fotomatón de pegatinas',
      xm_tea: 'Tienda de té de burbujas',
      xm_claw: 'Máquinas de gancho',
      xm_cinema: 'Taquilla del cine',
      xm_posters: 'Carteles de películas',
      xm_sneakers: 'Estante de zapatillas',
      xm_clothes: 'Perchero de ropa',
      xm_tattoo: 'Letrero del estudio de tatuajes',
      xm_busker: 'Artista callejero',
      xm_screen: 'Pantalla gigante',
      xm_plaque: 'Placa de Ximending en el suelo',
      xm_graffiti: 'Muro de grafitis',
      xm_redHouse: 'La Casa Roja',
      xm_market: 'Mercadillo creativo del fin de semana',
      xm_mrtL: 'Estación del MRT de Longshan',
      xm_dragonDoor: 'Puerta del Dragón (entrada)',
      xm_pillar: 'Columnas de dragones de bronce',
      xm_waterfall: 'Jardín de la cascada',
      xm_burner: 'Gran pebetero de incienso',
      xm_offer: 'Mesa de ofrendas',
      xm_moon: 'Bloques lunares',
      xm_sticks: 'Palitos de la fortuna',
      xm_roof: 'Tejado de cola de golondrina',
      xm_herbTea: 'Puesto de té de hierbas',
      xm_herbSign: 'Letrero del Callejón de las Hierbas',
      xm_bopiliao: 'Panel de historia de Bopiliao',
      xm_huaxi: 'Puerta de la calle Huaxi',
      xm_hxNoodle: 'Puesto de fideos danzai',
      xm_hxSoup: 'Puesto de sopa de cuatro hierbas',
      xm_chess: 'Mesa de ajedrez chino',
      xm_pigeons: 'Palomas',
      xm_canoe: 'Escultura de canoa',
      xm_fortune: 'Mesa del adivino',
      xm_oldIce: 'Heladería antigua',
    },
    npc: {
      xm_teen1: 'Chica que espera',
      xm_teen2: 'Chico con el móvil',
      xm_teen3: 'Chico con gorra',
      xm_meesuaLady: 'La tía del mee sua',
      xm_tourist: 'Turista perdido',
      xm_shopper1: 'Comprador',
      xm_shopper2: 'Fan de las zapatillas',
      xm_skater: 'Skater',
      xm_artist: 'Artista del mercadillo',
      xm_redGuide: 'Guía de la Casa Roja',
      xm_cosplayer: 'Cosplayer',
      xm_grandpaX: 'Abuelo cinéfilo',
      xm_volunteer: 'Voluntaria del templo',
      xm_fortuneGrandpa: 'Abuelo adivino',
      xm_worshipper1: 'Fiel',
      xm_worshipper2: 'Abuela con incienso',
      xm_incenseAuntie: 'Vendedora de incienso',
      xm_herbLady: 'Señora del té de hierbas',
      xm_chess1: 'Abuelo ajedrecista',
      xm_chess2: 'Mirón del ajedrez',
      xm_pigeonKid: 'Niño que mira las palomas',
      xm_bopiliaoGuide: 'Estudiante de historia',
      xm_nightVendor: 'Cocinero del mercado nocturno',
      xm_tourist2: 'Visitante extranjera',
      xm_taichi: 'Abuela del taichí',
    },
    items: {},

    common: {
      learned: '📘 ¡Has aprendido algo nuevo!',
      closed: 'Ahora está cerrado. El mercado nocturno abre por la tarde (a partir de las 5).',
      notEnough: 'No tienes suficientes monedas.',
      back: 'Volver',
    },

    // --- Ximending --------------------------------------------------------------------------
    exit6: {
      text: 'Salida 6 del MRT Ximen: el punto de encuentro más famoso de Taipéi. Cada fin de semana, los adolescentes esperan aquí a sus amigos.',
      phrase: 'Let’s meet at Exit 6!', // English practice
      ride: '🚇 Coger el MRT',
      practice: '🗣️ Practica quedar en inglés',
      q: 'Your friend asks: “Where shall we meet?”', // English practice
      a: ['Let’s meet at Exit 6 at three o’clock.', 'Meet you yesterday at the train.', 'I am Exit 6.'], // English practice
      right: '✅ ¡Perfecto! Di el sitio y la hora. Tu amigo responde: “See you there!”',
      wrong: 'Mmm, eso suena raro. ¡Di el sitio y la hora!',
    },
    mapBoard: {
      text: 'Un mapa de Ximending: la Calle del Cine arriba, la calle Emei en medio, y la Salida 6 y la Casa Roja abajo.',
      q: 'You are at Exit 6. How do you go to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side.', 'Take the escalator up to the sky.', 'Go inside the cinema.'], // English practice
      right: '✅ ¡Sí! La Casa Roja está justo al otro lado de la calle desde la Salida 6.',
      wrong: 'Vuelve a mirar el mapa: el edificio rojo está al otro lado de la calle grande.',
    },
    meesua: {
      vendor: 'Hello! Big bowl or small bowl?', // English practice
      ok: 'A small bowl of mee sua, please.', // English practice
      bad: ['Give me noodle now!', 'I am a small bowl.'], // English practice
      done: 'Here you go! Here we eat it standing up, with a spoon — no chopsticks. Careful, it’s hot!', // English practice
      after: 'El mee sua (麵線) es una sopa de fideos finos con tripa de cerdo y mucho ajo. No hay sillas: ¡todo el mundo se lo come de pie en la calle!',
    },
    tea: {
      vendor: 'Hi! What would you like? How sweet, and how much ice?', // English practice
      ok: 'A bubble milk tea, half sugar, less ice, please.', // English practice
      bad: ['Sugar me, please!', 'I want a hot ice cold tea big.'], // English practice
      done: 'One bubble milk tea, half sugar, less ice! Shake it before you drink!', // English practice
    },
    chicken: {
      vendor: 'Welcome! Spicy or not spicy? Shall I cut it?', // English practice
      ok: 'One chicken cutlet, not spicy, cut, please.', // English practice
      bad: ['Chicken! Chicken! Chicken!', 'Not cut spicy me chicken.'], // English practice
      done: 'Here you are! It’s bigger than your face!', // English practice
    },
    ice: {
      vendor: 'Hello! Mango or strawberry shaved ice?', // English practice
      ok: 'Could I have a mango shaved ice, please?', // English practice
      bad: ['Mango me!', 'I would like a hot snow, please.'], // English practice
      done: 'One mango shaved ice! It’s big — share it with a friend!', // English practice
    },
    claw: {
      text: 'Una tienda entera de máquinas de gancho (夾娃娃機). Diez monedas por intento. ¡El gancho es muy traicionero!',
      play: '🧸 Jugar (10 monedas)',
    },
    cinema: {
      text: 'Ximending lleva cien años siendo la calle del cine de Taipéi. ¿Qué película quieres ver?',
      films: ['Space Cat', 'Boba Quest', 'Robo Fu'],
      vendor: 'Hi! Which movie, and how many tickets?', // English practice
      ok: 'One ticket for {film}, please.', // English practice
      bad: ['Movie! One! Me!', 'I am a ticket for {film}.'], // English practice
      done: 'Here’s your ticket for {film}. Enjoy the movie!', // English practice
      watched: '🍿 Has visto {film}. ¡Qué peli tan divertida!',
    },
    posters: {
      text: 'Three posters: SPACE CAT — “A brave cat flies to the moon.” BOBA QUEST — “Two friends look for the best bubble tea.” TYPHOON! — “A family stays home in the storm.”', // English practice
      q: 'Who flies to the moon?', // English practice
      a: ['A brave cat.', 'Two friends.', 'A family.'], // English practice
      right: '✅ ¡Correcto! Space Cat va de un gato valiente.',
      wrong: '¡Vuelve a leer los carteles!',
    },
    sneakers: {
      text: 'Filas de zapatillas de colores. Las que te gustan te quedan pequeñas…',
      q: 'How do you ask for another size?', // English practice
      a: ['Do you have these in a bigger size?', 'Shoes bigger you have?', 'I size the shoes, please.'], // English practice
      right: '✅ ¡Genial! El dependiente sonríe: “Sure, let me check!”', // English practice
      wrong: 'Prueba con una pregunta educada: “Do you have…?”',
    },
    clothes: {
      text: 'Un perchero de rebajas con camisetas de todos los colores. Te gusta la amarilla.',
      q: 'How do you ask to try it on?', // English practice
      a: ['Can I try this on, please?', 'I try you on.', 'This is on me?'], // English practice
      right: '✅ ¡Sí! “The fitting room is at the back.”', // English practice
      wrong: 'Mmm. Empieza con “Can I…?”',
    },
    tattoo: {
      text: 'Un estudio de tatuajes. Los tatuajes de verdad son solo para adultos (18+)… ¡pero el artista se ofrece a dibujarte una estrella temporal en la mano!',
      get: '⭐ Una estrella temporal (10 monedas)',
      done: 'A sparkly star on your hand! “Temporary” means it washes off in a few days.', // English practice
    },
    sticker: {
      text: '¡Un fotomatón de pegatinas (大頭貼)! Elige un marco y posa. 30 monedas.',
      frames: ['🌸 Flores', '🐱 Orejas de gato', '✨ Purpurina'],
      cheese: 'Say cheese!', // English practice
      done: '¡Clic! Salen las pegatinas: ojos enormes, brillitos y tu mejor sonrisa.',
    },
    busker: {
      dancer: 'Un bailarín callejero hace popping y gira al ritmo de la música. La gente se pone en corro.',
      singer: 'Una cantante con guitarra toca una canción suave. La gente se balancea y graba con el móvil.',
      none: 'Ahora no actúa nadie. Los artistas callejeros de Ximending necesitan una licencia; actúan desde media mañana hasta la noche.',
      watch: '👀 Ver el espectáculo',
      tip: '🪙 Dar 10 monedas de propina',
      cheer: 'That was amazing!', // English practice
      watched: '👏 ¡Has aplaudido con todo el público!',
      thanks: 'The performer bows: “Thank you so much!”', // English practice
    },
    screen: {
      text: 'The giant screen flashes adverts all day: a concert, a new game, and a bubble tea ad that says “BUBBLE TEA NT$50”.', // English practice
      q: 'How much is the bubble tea in the ad?', // English practice
      a: ['Fifty dollars.', 'Fifteen dollars.', 'Five hundred dollars.'], // English practice
      right: '✅ Correcto: fifty (50). Cuidado: ¡fifteen es 15!',
      wrong: 'Mira otra vez: un 5 y un 0…',
    },
    plaque: {
      text: '“Ximen” (西門) significa Puerta Oeste: la puerta oeste de la antigua muralla de Taipéi estaba aquí cerca. Ximending (西門町) es el Barrio de la Puerta Oeste.',
      phrase: 'Ximending means West Gate District.', // English practice
    },
    graffiti: {
      text: 'En el Parque del Cine de Taipéi está permitido pintar en este muro: los artistas lo llenan de grafitis nuevos todo el rato.',
      q: 'What colour is the word 西門?', // English practice
      a: ['Pink.', 'Green.', 'Black.'], // English practice
      right: '✅ ¡Sí, rosa chillón!',
      wrong: '¡Mira el primer grafiti de la izquierda!',
    },
    redHouse: {
      text: 'La Casa Roja (西門紅樓) se construyó en 1908 como el primer mercado público de Taiwán. La fachada es un octógono, con una nave en forma de cruz detrás. Hoy está llena de tiendecitas de diseñadores jóvenes.',
      q: 'How many sides does an octagon have?', // English practice
      a: ['Eight.', 'Six.', 'Ten.'], // English practice
      right: '✅ ¡Ocho! “Octo” significa ocho, como el pulpo (octopus), que tiene ocho brazos.',
      wrong: '¡Cuenta los lados del edificio de delante!',
    },
    market: {
      text: 'El mercadillo creativo del fin de semana: llaveros hechos a mano, postales, joyas y té.',
      q: 'You like a keychain. What do you say?', // English practice
      a: ['How much is this keychain?', 'Keychain money you?', 'I am a keychain.'], // English practice
      right: '✅ “It’s 30 dollars. I made it myself!”', // English practice
      wrong: 'Prueba con “How much is…?”',
      buy: '🔑 Comprar el llavero (30 monedas)',
      bought: '¡Te has comprado un llavero hecho a mano!',
    },

    // --- Templo de Longshan -----------------------------------------------------------------
    mrtL: {
      text: 'Estación de Longshan. La salida da justo al parque de Bangka, enfrente del templo.',
      ride: '🚇 Coger el MRT',
    },
    etiquette: {
      intro: 'Antes de entrar, la voluntaria comprueba que conoces las normas del templo.',
      qs: [
        { q: 'Which door do you use to go IN?', a: ['The right door — the Dragon Door.', 'The middle door.', 'The left door — the Tiger Door.'] }, // English practice
        { q: 'And which door do you use to go OUT?', a: ['The left door — the Tiger Door.', 'The Dragon Door again.', 'Through the window.'] }, // English practice
        { q: 'Can you step on the wooden door sill?', a: ['No, step over it.', 'Yes, jump on it.', 'Sit on it.'] }, // English practice
      ],
      right: '✅ ¡Correcto!',
      wrong: '❌ No exactamente. Recuerda: ¡se entra por el dragón y se sale por el tigre!',
      done: 'Well done! “Enter by the right door (dragon side), exit by the left (tiger side).” The middle door is for the gods.', // English practice
    },
    pillar: {
      text: 'Una pareja muy especial de columnas de bronce protege la puerta principal: en cada una, un dragón se enrosca hasta el tejado.',
      q: 'What are these pillars made of?', // English practice
      a: ['Bronze — a metal.', 'Wood.', 'Chocolate.'], // English practice
      right: '✅ ¡De bronce! Tócalo con cuidado: está fresquito y liso.',
      wrong: 'Mmm. Son oscuras y brillantes, como monedas antiguas…',
    },
    waterfall: {
      text: 'Una pequeña cascada cae en un estanque de carpas koi a la entrada del templo. El sonido del agua ayuda a la gente a calmarse antes de rezar.',
      phrase: 'The water sounds so peaceful.', // English practice
    },
    burner: {
      text: 'El gran pebetero (天公爐) es para el Emperador de Jade, el dios del cielo. La gente sujeta el incienso con las dos manos, hace tres reverencias y pide un deseo en silencio.',
      bow: '🙏 Haz tres reverencias y pide un deseo',
      wish: 'I wish my family good health.', // English practice
      done: 'Haces tres reverencias. El humo sube hacia el cielo con tu deseo.',
    },
    offer: {
      text: 'Fruta, flores y pasteles para los dioses. La piña gusta mucho: en taiwanés, “piña” (ông-lâi) suena como “llega la buena suerte”.',
      q: 'Which fruit is yellow, spiky and sweet?', // English practice
      a: ['A pineapple.', 'A banana.', 'A grape.'], // English practice
      right: '✅ ¡Una piña! 旺來: ¡llega la buena suerte!',
      wrong: 'Pincha… y es amarilla…',
    },
    moon: {
      text: 'Bloques lunares (擲筊, “poe”): hazles a los dioses en tu corazón una pregunta de sí o no, y luego deja caer los dos bloques rojos en forma de media luna.',
      throw: '🌙 Haz una pregunta y lanza',
      results: [
        { name: '聖筊 — Respuesta sagrada', text: 'Un lado plano arriba y un lado redondo arriba: ¡la respuesta es SÍ!', en: 'The answer is yes!' }, // English practice
        { name: '笑筊 — Respuesta risueña', text: 'Los dos lados planos arriba: los dioses se ríen. Tu pregunta no está clara, ¡vuelve a preguntar!', en: 'Please ask again.' }, // English practice
        { name: '陰筊 — Respuesta enfadada', text: 'Los dos lados redondos arriba: la respuesta es NO, o ahora no.', en: 'The answer is no.' }, // English practice
      ],
      again: '🌙 Lanzar otra vez',
    },
    sticks: {
      text: 'Palitos de la fortuna (求籤): agita el cubilete de bambú hasta que caiga un palito con un número, y luego busca su poema en los cajoncitos.',
      shake: '🎋 Agitar el cubilete',
      got: '¡Cae el palito número {n}! Tu fortuna dice:',
      fortunes: [
        'Slow and steady wins the race. Keep going!', // English practice
        'A good friend will help you very soon.', // English practice
        'Be brave and say hello: a new friend is waiting.', // English practice
        'Your hard work will grow like a tree.', // English practice
        'Share what you have, and happiness comes back to you.', // English practice
        'Listen carefully today: you will learn something important.', // English practice
        'After the rain comes the rainbow.', // English practice
        'Your family is proud of you.', // English practice
      ],
    },
    roof: {
      text: '¡Mira hacia arriba! Las puntas del tejado se curvan hacia arriba como la cola de una golondrina (燕尾脊). Los caballetes están cubiertos de dragones y figuritas hechas con trocitos de porcelana de colores (剪黏).',
      q: 'What bird do the roof ends look like?', // English practice
      a: ['A swallow.', 'A penguin.', 'A chicken.'], // English practice
      right: '✅ ¡Una golondrina! Por eso se llaman tejados de cola de golondrina.',
      wrong: 'Un pájaro pequeño con la cola en forma de horquilla…',
    },
    herbTea: {
      vendor: 'Herbal tea! It cools you down. Hot or cold?', // English practice
      ok: 'A cup of cold herbal tea, please.', // English practice
      bad: ['Herb me cold!', 'I am a herbal tea.'], // English practice
      done: 'Here you go. It’s a little bitter, but perfect on a hot day!', // English practice
    },
    herbSign: {
      text: 'El Callejón de las Hierbas (青草巷): desde hace más de cien años, estas tiendas venden hierbas frescas para hacer té y remedios caseros de toda la vida.',
      phrase: 'These herbs smell fresh.', // English practice
    },
    bopiliao: {
      text: 'Bopiliao (剝皮寮) es una de las calles antiguas mejor conservadas de Taipéi: casas-tienda de ladrillo rojo de la dinastía Qing y de la época japonesa, con soportales (騎樓) para protegerse de la lluvia.',
      q: 'What are the old buildings made of?', // English practice
      a: ['Red bricks.', 'Glass.', 'Snow.'], // English practice
      right: '✅ ¡De ladrillo rojo! Y los soportales protegen del sol y de la lluvia.',
      wrong: 'Mira las paredes: son rojas…',
    },
    huaxi: {
      text: 'El mercado nocturno de la calle Huaxi (華西街夜市) es uno de los más antiguos de Taipéi, con una calle cubierta detrás de su recargada puerta roja. Los puestos abren por la tarde.',
    },
    hxNoodle: {
      vendor: 'Danzai noodles! Small bowls, big taste. How many?', // English practice
      ok: 'One bowl of danzai noodles, please.', // English practice
      bad: ['Noodle one me!', 'I would like a bowl of chopsticks.'], // English practice
      done: 'Here you are! Shrimp, pork and a little egg on top.', // English practice
    },
    hxSoup: {
      vendor: 'Four-herb soup, nice and warm. Want one?', // English practice
      ok: 'Can I have a four-herb soup, please?', // English practice
      bad: ['Soup! Give!', 'I am four herbs.'], // English practice
      done: 'Here! It’s good for your tummy.', // English practice
    },
    chess: {
      text: 'Dos abuelos juegan al ajedrez chino (象棋) bajo el baniano. ¡Un corro de gente mira y da consejos que nadie ha pedido!',
      q: 'In chess, what do you say when you attack the king?', // English practice
      a: ['Check!', 'Hello!', 'Goodbye!'], // English practice
      right: '✅ “Check!” El abuelo se ríe: “Your move!”', // English practice
      wrong: 'Es una palabra corta… empieza por “ch”.',
    },
    pigeons: {
      text: 'Una bandada de palomas picotea por el parque y luego echa a volar todas a la vez.',
      q: 'Count them in English! How many pigeons?', // English practice
      a: ['Eleven.', 'Seven.', 'Twenty.'], // English practice
      right: '✅ ¡Once! Bien contado.',
      wrong: '¡Vuelve a contar, despacito!',
    },
    canoe: {
      text: '“Bangka” (艋舺), el antiguo nombre de Wanhua, viene de la palabra ketagalan para “canoa”. Hace mucho tiempo, la gente remaba en canoa por el río para comerciar.',
      phrase: 'Bangka means canoe.', // English practice
    },
    fortune: {
      text: 'El abuelo adivino te mira la mano y sonríe.',
      reads: [
        'You will learn a lot of English this year.', // English practice
        'You have a kind heart. People like to be near you.', // English practice
        'Something you lost will come back to you.', // English practice
        'A trip will bring you a happy surprise.', // English practice
      ],
      thanks: 'Thank you, grandpa!', // English practice
    },
    oldIce: {
      vendor: 'Welcome to our old ice shop! Since 1960! What would you like?', // English practice
      ok: 'One bowl of fruit shaved ice, please.', // English practice
      bad: ['Ice fruit me now!', 'I would like a hot snowman.'], // English practice
      done: 'Here you go! Mango, watermelon and pineapple on fluffy ice.', // English practice
    },

    // --- Personas ---------------------------------------------------------------------------
    talk: {
      xm_teen1: ['Estamos esperando a nuestros amigos. ¡Todo el mundo queda en la Salida 6!', 'Práctica de inglés: “I’m here! Where are you?”', 'Después vamos a por té de burbujas. Con media azúcar, claro.'],
      xm_teen2: ['Mi amiga llega tarde otra vez… Dice “I’m on my way!”', 'Ximending es el mejor sitio para hacer fotos. ¡Mira cuántos neones!'],
      xm_teen3: ['¿Has probado el fotomatón de pegatinas? ¡Te pone unos ojos enormes!', 'Práctica de inglés: “Let’s take a selfie!”'],
      xm_shopper1: ['Estas zapatillas están de oferta: ¡compras unas y te regalan otras!', 'Práctica de inglés: “It’s on sale!” quiere decir que está más barato de lo normal.'],
      xm_shopper2: ['Colecciono zapatillas. ¡Tengo treinta pares!', 'Aquí las tiendas abren tarde, hacia las once, y cierran muy tarde.'],
      xm_skater: ['El Parque del Cine de Taipéi es el mejor sitio para patinar. ¡Y puedes pintar en el muro!', 'Práctica de inglés: “Watch this trick!”'],
      xm_artist: ['Hago los llaveros a mano. ¡Cada uno es diferente!', 'Vuelve el sábado o el domingo para el mercadillo creativo.'],
      xm_redGuide: ['La Casa Roja abrió en 1908 como mercado. ¡Luego fue un teatro y también un cine!', 'Práctica de inglés: “octagon” = 8 lados, “cross” = ✚.'],
      xm_cosplayer: ['¡Hoy voy disfrazada de mi heroína de anime favorita!', 'Práctica de inglés: “Can I take a photo with you?” — “Sure!”'],
      xm_grandpaX: ['¡Cuando yo era joven, Ximending tenía más de veinte cines!', 'En la Calle del Cine aún quedan cines antiguos. El cine es magia, chaval.'],
      xm_volunteer: [],
      xm_fortuneGrandpa: [],
      xm_worshipper1: ['Vengo todos los domingos a rezar por mi familia.', 'Práctica de inglés: “I pray for good health.”'],
      xm_worshipper2: ['El templo de Longshan tiene casi trescientos años. ¡Se construyó en 1738!', 'Aquí viven muchos dioses: Guanyin, Mazu… ¡y hasta el dios de los exámenes!'],
      xm_incenseAuntie: ['¡Incienso y flores para los dioses! Hoy tengo flores frescas.', 'Práctica de inglés: “Would you like some incense?”'],
      xm_chess2: ['Psst… debería mover el caballo. ¡No le digas que te lo he dicho!', 'En el ajedrez chino las piezas son redondas y llevan caracteres escritos.'],
      xm_pigeonKid: ['¡Cuando alguien corre, las palomas echan a volar todas juntas! Chis, camina despacio.', 'Práctica de inglés: “Look! They’re flying!”'],
      xm_bopiliaoGuide: ['Estudio la historia de Wanhua. ¡Esto era el puerto con más movimiento de Taipéi!', 'Aquí se ruedan películas porque la calle parece muy antigua.'],
      xm_nightVendor: ['El mercado nocturno abre a las cinco. ¡Ven con hambre!', 'Práctica de inglés: “What do you recommend?” — “The danzai noodles!”'],
      xm_taichi: ['¡El taichí de cada mañana me mantiene joven! Despacio… y… respira.', 'Práctica de inglés: “Breathe in… breathe out.”'],
    },
    tourist: {
      ask: 'Excuse me! How do I get to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side, near Exit 1.', 'Turn into a cinema and jump.', 'I am the Red House.'], // English practice
      right: '✅ “Thank you so much! You speak great English!”', // English practice
      wrong: 'El turista pone cara de no entender nada. ¡Inténtalo otra vez!',
    },
    tourist2: {
      ask: 'Excuse me, which door do I use to go into the temple?', // English practice
      a: ['The right door — the Dragon Door.', 'The middle door, it’s the biggest.', 'Any window is fine.'], // English practice
      right: '✅ “The Dragon Door, thank you! And out by the Tiger Door?” — “Yes!”', // English practice
      wrong: 'Mmm… ¡acuérdate del dragón y del tigre!',
    },
    chessTalk: '“Your move!” The grandpa waits for you to watch closely.', // English practice
    incenseBuy: '🌸 Comprar incienso (5 monedas)',
    incenseBought: 'Has comprado tres varitas de incienso. ¡Úsalas en el gran pebetero!',
  },
};
